import { TargetIndustry, TargetRegion } from "../types/apiTypes";
import { DropdownNestedItem } from "../types/genereal";

export const toDropdownIndustries = (industries: TargetIndustry[]): DropdownNestedItem[] => {
  return industries.map(({ name, sub_industries, is_all_sub_industries }) => ({
    name,
    selected: is_all_sub_industries,
    nestedItems: sub_industries,
  }));
};

export const toDropdownRegions = (regions: TargetRegion[]): DropdownNestedItem[] => {
  return regions.map(({ name, countries, is_all_countries }) => ({
    name,
    selected: is_all_countries,
    nestedItems: countries,
  }));
};
